// import { useAlert } from 'context/alert';
// import React from 'react';


// const Alert = () => {
//   const { alert } = useAlert();

//   if (!alert.show) return null;

//   return (
//     <div 
//       className={`alert alert-${alert.type} alert-dismissible fade show position-fixed top-0 end-0 m-3 small`} 
//       role="alert"
//       style={{ width: 'auto', minWidth: '250px', zIndex: 9999 }}
//     >
//       {alert.message}
//       <button type="button" className="btn-close" aria-label="Close"></button>
//     </div>
//   );
// };

// export default Alert;

import { useAlert } from 'context/alert';
import React, { useState, useEffect } from 'react';

const Alert = () => {
  const { alert, hideAlert } = useAlert();
  const [showDetails, setShowDetails] = useState(false);

  useEffect(() => {
    setShowDetails(false);
  }, [alert]);

  if (!alert.show) return null;

  return (
    <div
      className={`alert alert-${alert.type} alert-dismissible fade show position-fixed top-0 end-0 m-3 small`}
      role="alert"
      style={{ width: 'auto', minWidth: '250px', zIndex: 9999 }}
    >
      <p>{alert.message}</p>

      {alert.detail && (
        <>
          <p
            className="p-0 border-0 cursor-pointer"
            onClick={() => setShowDetails(!showDetails)}
          >
            {showDetails ? "View Less" : "View More"}
          </p>

          {showDetails && <p className="mt-1 text-muted small">{alert.detail}</p>}
        </>
      )}

      <button type="button" className="btn-close" onClick={hideAlert} aria-label="Close"></button>
    </div>
  );
};

export default Alert;